import { AxiosInstance } from 'axios';

import { Appointment } from '../../components/_temp_ui_common/Appointments/types';

export interface UpdateAppointmentResponse {
  appointment: Appointment;
}

export const updateAppointment = (
  axiosInstance: AxiosInstance,
  id: string,
  params: Partial<Appointment>,
) => {
  return axiosInstance
    .patch<UpdateAppointmentResponse>(`/appointments/${id}`, params)
    .then(d => d.data.appointment);
};
